import type { Translatable } from "@/modules/l10n/getTransText.ts";
import { Trans } from "@lingui/react/macro";

export const GB = <Trans comment="unit: gigabytes">GB</Trans>;
export const MB = <Trans comment="unit: megabytes">MB</Trans>;
export const MB_P_S = <Trans comment="unit: megabytes per second">MB/s</Trans>;
export const MBIT_P_S = <Trans comment="unit: megabits per second">Mbit/s</Trans>;

export const qtyUnitLabels = {
    GBh: <Trans comment="unit: gigabyte-hours (storage usage)">GBh</Trans>,
    h: <Trans comment="unit: hours">h</Trans>,
    pc: <Trans comment="unit: pieces">pc</Trans>,
    // XXX: What is this?
    ih: "ih",
} satisfies Record<string, Translatable>;

export const label_GB_RAM = <Trans comment="Example: 16 GB (of) RAM">GB RAM</Trans>;
export const label_GB_disk = (
    <span className="uppercase">
        <Trans comment="Example: 50 GB (of) disk">GB disk</Trans>
    </span>
);
